'use client';

import { PropsWithChildren } from 'react';
import styles from './ProductListTemp.module.css';

type Props = {
  col: number;
  columnGap?: number;
  rowGap?: number;
};

export const ProductListTemp = ({ children, col, columnGap = 10, rowGap = 20 }: PropsWithChildren<Props>) => {
  return (
    <ul
      className={styles.productList}
      style={{
        gridTemplateColumns: `repeat(${col}, minmax(0, 1fr))`,
        columnGap,
        rowGap,
      }}
    >
      {children}
    </ul>
  );
};
